<template>
  <b-modal ref="OrderedProductModal" size="lg">
    <div slot="modal-title">
      <div class="d-flex">
        <h5 class="modal-title">Ordered Products</h5>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <label>{{period}}</label>
    </div>
    <div class="d-flex justify-content-end">
      <multiselect v-model="dimension" :max-height="200" :close-on-select="false"
                   placeholder="" :options="dimensions" :multiple="true"
                   select-label="" deselect-label="" selected-label="" :allow-empty="false"
                   @input="changeHideStateOfColumns" class="dimension"></multiselect>
    </div>
    <div>
      <ag-grid-vue class="ag-theme-balham grid"
                   :gridOptions="gridOptions" :columnDefs="columns" :rowData="rowData">
      </ag-grid-vue>
    </div>
    <div slot="modal-footer" class="w-100 text-center">
    </div>
  </b-modal>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import Multiselect from 'vue-multiselect';
  import { LinkCellRenderer, formatNumber, alignCells, autoResize } from '@/helpers/renderHelpers'
  import { existenceFloatingAndBundles } from '@/helpers/order-products-helpers';

  export default {
    components: {
      AgGridVue,
      Multiselect
    },
    data() {
      return {
        dimensions: ['m3', 'm2', 'lm', 'pieces'],
        dimension: 'm3',
        gridOptions: {
          suppressPropertyNamesCheck: true,
          components: {
            'SalesOrderLink': LinkCellRenderer('sales_order_id', `/sales-orders/`)
          },
          defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            enableRowGroup: true,
            valueFormatter(params) {
              return formatNumber(params.value, null);
            },
            cellStyle(params) {
              return alignCells(params);
            }
          },
          onRowDataChanged() {
            if (this.rowData && this.rowData.length) {
              autoResize(this);
            }
          }
        },
        rowData: [],
        period: '',
        columns: [
          {
            headerName: '',
            cellRenderer: existenceFloatingAndBundles,
            minWidth: 20,
          },
          {
            field: 'sales_order__descriptor',
            headerName: 'Order',
            minWidth: 65,
            cellRenderer: 'SalesOrderLink'
          },
          {
            field: 'product_name__name',
            headerName: 'Product',
            minWidth: 65,
          },
          {
            field: 'package_type__name',
            headerName: 'Bundles',
            key: 'tree__name',
            minWidth: 65,
          },
          {
            field: 'pack_size',
            headerName: 'Qty.',
            minWidth: 50,
          },
          {
            field: 'sales_order__delivery_date',
            headerName: 'Date',
            minWidth: 60,
          },
          {
            field: 'ordered_m3',
            headerName: 'ORD(m3)',
            minWidth: 65,
            totalDimension: true, aggFunc: 'sum',
          },
          {
            field: 'overload_m3',
            headerName: 'OVR(m3)',
            minWidth: 65,
            totalDimension: true, aggFunc: 'sum'
          },
          {
            field: 'ordered_m2',
            headerName: 'ORD(m2)',
            minWidth: 65,
            totalDimension: true, aggFunc: 'sum'
          },
          {
            field: 'overload_m2',
            headerName: 'OVR(m2)',
            minWidth: 65,
            totalDimension: true, aggFunc: 'sum'
          },
          {
            field: 'ordered_lm',
            headerName: 'ORD(lm)',
            minWidth: 65,
            totalDimension: true, aggFunc: 'sum'
          },
          {
            field: 'overload_lm',
            headerName: 'OVR(lm)',
            minWidth: 65,
            totalDimension: true, aggFunc: 'sum'
          },
          {
            field: 'ordered_pieces',
            headerName: 'ORD(pcs)',
            minWidth: 65,
            totalDimension: true, aggFunc: 'sum'
          },
          {
            field: 'overload_pieces',
            headerName: 'OVR(pcs)',
            minWidth: 65,
            totalDimension: true, aggFunc: 'sum'
          }
        ]
      }
    },
    methods: {
      changeHideStateOfColumns() {
        this.columns = this.columns.map(column => {
          if (column.field && column.totalDimension) {
            const columnType = column.field.split('_')[1];
            column.hide = !this.dimension.includes(columnType);
          }
          return column;
        })
      }
    },
    mounted() {
      this.$root.$on('openOrderedProductModal', data => {
        if (this.$refs['OrderedProductModal']) {
          this.$refs['OrderedProductModal'].show();
          this.changeHideStateOfColumns();
          this.rowData = data.products;
          this.period = `${data.period_date_start} - ${data.period_date_end}`;
        }
      });
    },
    beforeDestroy() {
      this.$root.$off('openOrderedProductModal');
    }
  }
</script>

<style>
  .dimension {
    width: 30%;
  }

  .grid {
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/OrderedProductModal.vue